module.exports = __webpack_public_path__ + "img/column_202509.81e02293.jpg";